var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "air-tree-wrappers dg-tree" }, [
    _c("div", { staticClass: "el-dialog__title" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm.screen
          ? _c("el-input", {
              staticClass: "input",
              attrs: {
                placeholder: _vm.placeholder,
                "prefix-icon": "el-icon-search",
              },
              on: { input: _vm.changeFilterText },
              model: {
                value: _vm.filterText,
                callback: function ($$v) {
                  _vm.filterText = $$v
                },
                expression: "filterText",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("el-tree", {
          ref: "tree",
          staticClass: "filter-tree",
          attrs: {
            "highlight-current": true,
            data: _vm.treeList,
            props: _vm.defaultProps,
            "show-checkbox": _vm.checkbox,
            "expand-on-click-node": _vm.expandOnClickNode,
            "default-expand-all": _vm.defaultExpandAll,
            "default-checked-keys": _vm.defaultCheckedKeys,
            "default-expanded-keys": _vm.defaultExpandedKeys,
            "filter-node-method": _vm.filterNode,
            "render-content": _vm.sonRenderContent,
            lazy: _vm.lazy,
            "check-strictly": _vm.checkStrictly,
            "current-node-key": _vm.currentNodeKey,
            load: _vm.load,
            accordion: _vm.accordion,
            draggable: _vm.draggable,
            "allow-drop": _vm.allowDrop,
            "allow-drag": _vm.allowDrag,
            "query-terms": _vm.queryTerms,
            "node-key": _vm.nodeKey,
          },
          on: {
            "node-drag-start": _vm.handleDragStart,
            "node-drag-enter": _vm.handleDragEnter,
            "node-drag-leave": _vm.handleDragLeave,
            "node-drag-over": _vm.handleDragOver,
            "node-drag-end": _vm.handleDragEnd,
            "node-drop": _vm.handleDrop,
            "check-change": _vm.check,
            "node-click": _vm.nodeclick,
          },
          nativeOn: {
            contextmenu: function ($event) {
              return _vm.contextmenu.apply(null, arguments)
            },
          },
        }),
        _vm._v(" "),
        _c("dg-contextmenu", {
          attrs: { "context-menu-data": _vm.contextMenuData },
          on: { createRootNode: _vm.createRootNode },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "foot" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }